import React from 'react'
import Button from "@mui/material/Button";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import {useRouter} from "next/router";
const ButtonPreviews = ({text,href})=>{
    const router = useRouter()
    return( <Button onClick={()=>router.push(href)} startIcon={<ArrowBackIosNewIcon />} color={"inherit"}  sx={{fontSize:'12px', textTransform:'none'}} >{text}</Button>)
}
export  default  ButtonPreviews